








import Vue from "vue";
import { Component } from "vue-property-decorator";
import ApiFactory from "../../api/ApiFactory";
import { LiabilityTypeDto } from "@/api/ClientPortalApiClient";

@Component({})
export default class CbxLiabilityTypes extends Vue {
  private types: LiabilityTypeDto[] | null = [];
  private selectedType = new LiabilityTypeDto();
  public created() {
    this.getAvailableTypes();
  }

  public setSelected(type: LiabilityTypeDto | undefined) {
    if (type) {
      this.selectedType = type;
    }
  }

  public typeSelected(type: LiabilityTypeDto) {
    this.$emit("liabilityTypeSelected", type);
  }

  private getAvailableTypes() {
    const api = ApiFactory.CreateDataClient();
    api
      .liabilityType_IndexAll()
      .then(result => {
        if (result) {
          this.types = result;
        } else {
          this.types = [];
        }
      })
      .catch(error => {
        console.log(error);
        this.types = [];
      });
  }
}
